import { TranslatePipe } from '../../../../core/_pipes/pipes/translate.pipe';
import { EmailAction, EmailActionOption } from '../../models/email-action.model';
import { Injectable } from '@angular/core';
import { consoleLogDevEnv } from '../../../../core/_helpers/util';

export enum EmailActionLocation {
  READ_MESSAGE,
  TRACKER_LIST,
}

@Injectable({
  providedIn: 'root',
})
export class EmailActionService {

  constructor(protected _translate: TranslatePipe) {
  }

  public getOption(location: EmailActionLocation = EmailActionLocation.READ_MESSAGE, fromArchiver: boolean = false): EmailActionOption[] {
    consoleLogDevEnv({ 'EmailActionService.getOption() fromArchiver': fromArchiver });

    const filters: EmailAction[] = [];

    if (location !== EmailActionLocation.TRACKER_LIST) {
      filters.push(EmailAction.ExportData);
    }

    if (fromArchiver) {
      filters.push(EmailAction.Release);
      filters.push(EmailAction.ReleaseAV);
      filters.push(EmailAction.Delete);
      filters.push(EmailAction.SenderBlocked);
      filters.push(EmailAction.SenderTrusted);
    }

    let optionsList = [
      {
        id: EmailAction.ExportData,
        name: this._translate.transform('btn_export_data', 'labels'),
      },
      {
        id: EmailAction.Release,
        name: this._translate.transform('release', 'labels'),
      },
      {
        id: EmailAction.ReleaseAV,
        name: this._translate.transform('releaseAv', 'labels'),
      },
      {
        id: EmailAction.Delete,
        name: this._translate.transform('delete'),
      },
      {
        id: EmailAction.Redirect,
        name: this._translate.transform('rules_redirect'),
      },
      {
        id: EmailAction.Phishing,
        name: this._translate.transform('report') + ' Phishing',
      },
      {
        id: EmailAction.Spam,
        name: this._translate.transform('report') + ' Spam',
      },
      {
        id: EmailAction.NotSpam,
        name: this._translate.transform('report') + ' Not-Spam',
      },
      {
        id: EmailAction.SenderBlocked,
        name: this._translate.transform('senderToBlockedList', 'labels'),
      },
      {
        id: EmailAction.SenderTrusted,
        name: this._translate.transform('senderToTrustedList', 'labels'),
      },
    ];

    if (filters) {
      for (const filter of filters) {
        optionsList = optionsList.filter((option) => option.id !== filter);
      }
    }

    return optionsList;
  }
}
